import React from 'react';

import {
  DateField,
  TextField,
} from 'react-admin';

import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Box,
  Divider,
} from '@mui/material';

import ColoredScoreField from '../../customFields/ColoredScoreField';

import SanctionTitle from './SanctionTitle';

const SanctionMatchInformation = () => (
  <Grid size={12}>
    <Card variant="outlined" sx={{ margin: 0 }}>
      <CardHeader title="Match information" />
      <Divider />
      <CardContent>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <SanctionTitle>Provider name</SanctionTitle>
            <TextField source="providerName" emptyText="-" />
          </Box>
          <Box>
            <SanctionTitle>Match %</SanctionTitle>
            <ColoredScoreField source="matchProbability" />
          </Box>
          <Box>
            <SanctionTitle>Last updated</SanctionTitle>
            <DateField showTime source="createdAt" emptyText="-" />
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Grid>
);

export default SanctionMatchInformation;
